import { ChangeDetectionStrategy, Component, HostBinding, inject, Input } from '@angular/core';
import { LinkService } from '@core/services/link.service';
import { Bind } from '@noda-lib/utils/decorators';
import { LanguageService } from '@translate/services/language.service';
import { THashMap } from 'i18n';

import { TranslateImports } from './translate.imports';

@Component({
  selector: 'noda-translate',
  templateUrl: './translate.component.html',
  styleUrls: ['./translate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: TranslateImports,
})
export class TranslateComponent {
  protected linkService: LinkService = inject(LinkService);

  @Input() public params: THashMap = null;
  @Input() public lang: string = null;

  @Input()
  @HostBinding('attr.data-i18n-key')
  public key!: string;

  constructor(private langService: LanguageService) {}

  @Bind()
  protected replaceLinkWithTag(value: string): string {
    return this.linkService.replaceLinkWithTag(value);
  }

  protected get currentLanguage(): string {
    return this.lang || this.langService.activeLang;
  }
}
